<template>
	<div class='performer-container'>
			<p-multiselect :disabled="!actLpoIsDraft"
				v-model='inputPerformer'
                :options='listPerformers'
                :multiple="true"
                :filter="true"
                optionLabel='name'
				dataKey='id'
                @hide="changePerformer"
			/>
	</div>
</template>
<!--:options='regionList'
:loading='loadingRegionList'
:disabled='loadingRegionList || !selectedFo'
-->
<script>
	export default {
  	components: {  },
		name: 'InspectionPerformer',
		data: () => ({
            inputPerformer: null
		}),
		computed: {
			actLpoIsDraft() { return this.$store.getters['lpoData/actLpoIsDraft']; },
			lpo() {
				return this.$store.state.selectedLpo.lpo;
			},
            listPerformers() {
                return this.$store.state.selectedLpo.performers;
            },

            performer: {
                get() {
					return this.$store.state.selectedLpo.savedPerformer;
				},
				set(value) {
					//console.log(value)
                    //console.log(this.$store.state.selectedLpo.savedPerformer)
                    //this.$store.dispatch('selectedLpo/updatePerformer', value).then(res => {
                        //this.$store.dispatch('selectedLpo/getPerformer', this.lpo.lpo_id)
                    //});
                    this.inputPerformer = value
				}
            },
		},

		watch: {
			
		},

		methods: {
            changePerformer() {
                if(this.inputPerformer.length < 5) {
                    this.$store.dispatch('selectedLpo/updatePerformer', this.inputPerformer).then(res => {
                        this.$store.dispatch('selectedLpo/getPerformer', this.lpo.lpo_id).then(res => {
                            this.inputPerformer = this.performer
                        })
                    });
                } else {
                    this.inputPerformer = this.performer
                }
            },
		},
		created() {
            const filialId = this.$store.state.user.user.filial_id;
            this.$store.dispatch('selectedLpo/getPerformers', filialId);
            this.$store.dispatch('selectedLpo/getPerformer', this.lpo.lpo_id).then(res => {
                this.inputPerformer = this.performer;
            });
		}
	};
</script>

<style scoped>
	.performer-container {
		display: flex;
		align-items: center;
		gap: 10px;
	}
    .p-progress-spinner {
		height: 24px;
		width: 24px;
	}

	.p-dropdown,
	.p-multiselect {
		width: 100%;
		border-radius: 2px;
	}

	.p-dropdown::v-deep .p-dropdown-label,
	.p-multiselect::v-deep .p-multiselect-label {
		overflow: visible;
		white-space: normal;
	}

	.p-dropdown::v-deep .p-dropdown-label.p-placeholder,
	.p-multiselect::v-deep .p-multiselect-label.p-placeholder {
		color: $placeholder-color;
	}

	.p-dropdown::v-deep .p-dropdown-panel,
	.p-multiselect::v-deep .p-multiselect-panel {
		width: 100%;
	}

	.p-dropdown::v-deep .p-dropdown-items-wrapper,
	.p-multiselect::v-deep .p-multiselect-items-wrapper {
		width: 100%;
	}

	.p-dropdown::v-deep .p-dropdown-item,
	.p-multiselect::v-deep .p-multiselect-item {
		white-space: normal;
	}
</style>